module.exports = __webpack_public_path__ + "img/1145020758.9017569c.jpg";